export const getFramesIconSvg = (
  width = 24,
  height = 18
) => `<svg width=${width} height=${height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2V22H5V20.1611H19V22H21V2H3ZM19 18.1611V4H5V18.1611H19Z" fill="#111111"/>
</svg>
`;
